export default ({	open: t = false, focus: e = false } = {}) => ({
	__type: "Popover",
	open: t,
	init() {
		e && this.$watch("open", (t => {
			t && this.$nextTick((() => {
				! function (t) {
					const e = Array.from(t.querySelectorAll("[contentEditable=true]:not([tabindex='-1']),[tabindex]:not([tabindex='-1']),a[href]:not([tabindex='-1']),area[href]:not([tabindex='-1']),button:not([disabled]):not([tabindex='-1']),iframe:not([tabindex='-1']),input:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),textarea:not([disabled]):not([tabindex='-1'])"));
					! function t(i) {
						void 0 !== i && (i.focus({
							preventScroll: !0
						}), document.activeElement !== i && t(e[e.indexOf(i) + 1]))
					}(e[0])
				}(this.$refs.panel)
			}))
		}));
		let t = i => {
			if (!document.body.contains(this.$el)) return void window.removeEventListener("focus", t, !0);
			let n = e ? this.$refs.panel : this.$el;
			if (this.open && i.target instanceof Element && !n.contains(i.target)) {
				if (this.popoverGroup !== null) return;
				this.open = !1
			}
		};
		window.addEventListener("focus", t, !0)
	},
	onEscape() {
		this.open = !1, this.restoreEl && this.restoreEl.focus()
	},
	onClosePopoverGroup(t) {
		t.detail.contains(this.$el) && (this.open = !1)
	},
	toggle(t) {
		this.open = !this.open, this.open ? this.restoreEl = t.currentTarget : this.restoreEl && this.restoreEl.focus()
	}
})
